export default __webpack_public_path__ + "static/media/fin.91b1111e.png";